export default __webpack_public_path__ + "static/media/likeOutlined.df44edfe.svg";